<div class="main-container">
    <mat-dialog-content class="mat-typography">
        {{ data.message | translate }}
    </mat-dialog-content>
   
  <mat-dialog-actions fxLayoutAlign="end">
    <rezolve-secondary-button mat-dialog-close>OK</rezolve-secondary-button>
  </mat-dialog-actions>
</div>